import Yup from '_zari/validation/_yup'

const validationSchema = Yup.object().shape({
  idUsuario: Yup.string().required('El campo es requerido.'),
  codigo: Yup.string().required('El campo es requerido.'),
  nombre: Yup.string().required('El campo es requerido.'),
  estado: Yup.string().required('El campo es requerido.')
})

export default validationSchema
